(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ "./node_modules/@chakra-ui/select/dist/index.esm.js":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ph": function() { return /* binding */ Select; }
/* harmony export */ });
/* unused harmony exports DefaultIcon, SelectField */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@chakra-ui/form-control/dist/index.esm.js");
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@chakra-ui/styled-system/dist/index.esm.js");
// ../../../react-shim.js


// src/select.tsx



// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
var dataAttr = (condition) => condition ? "" : void 0;

// ../../utilities/object-utils/src/index.ts
function split(object, keys) {
  const picked = {};
  const omitted = {};
  for (const [key, value] of Object.entries(object)) {
    if (keys.includes(key))
      picked[key] = value;
    else
      omitted[key] = value;
  }
  return [picked, omitted];
}

// src/select.tsx


// src/select-field.tsx

var SelectField = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)(function SelectField2(props, ref) {
  const { children, placeholder, className, ...rest } = props;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.select */ .m$.select, {
    ...rest,
    ref,
    className: cx("chakra-select", className)
  }, placeholder && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("option", {
    value: ""
  }, placeholder), children);
});
SelectField.displayName = "SelectField";

// src/select.tsx
var Select = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)((props, ref) => {
  var _a;
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useMultiStyleConfig */ .jC)("Select", props);
  const {
    rootProps,
    placeholder,
    icon,
    color,
    height,
    h,
    minH,
    minHeight,
    iconColor,
    iconSize,
    ...rest
  } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .omitThemingProps */ .Lr)(props);
  const [layoutProps, otherProps] = split(rest, _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .layoutPropNames */ .oE);
  const ownProps = (0,_chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_3__/* .useFormControl */ .Yp)(otherProps);
  const rootStyles = {
    width: "100%",
    height: "fit-content",
    position: "relative",
    color
  };
  const fieldStyles = {
    paddingEnd: "2rem",
    ...styles.field,
    _focus: {
      zIndex: "unset",
      ...(_a = styles.field) == null ? void 0 : _a["_focus"]
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.div */ .m$.div, {
    className: "chakra-select__wrapper",
    __css: rootStyles,
    ...layoutProps,
    ...rootProps
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectField, {
    ref,
    height: h ?? height,
    minH: minH ?? minHeight,
    placeholder,
    ...ownProps,
    __css: fieldStyles
  }, props.children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectIcon, {
    "data-disabled": dataAttr(ownProps.disabled),
    ...(iconColor || color) && { color: iconColor || color },
    __css: styles.icon,
    ...iconSize && { fontSize: iconSize }
  }, icon));
});
Select.displayName = "Select";
var DefaultIcon = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
  viewBox: "0 0 24 24",
  ...props
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fill: "currentColor",
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}));
var IconWrapper = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra */ .m$)("div", {
  baseStyle: {
    position: "absolute",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    top: "50%",
    transform: "translateY(-50%)"
  }
});
var SelectIcon = (props) => {
  const { children = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DefaultIcon, null), ...rest } = props;
  const clone = (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(children, {
    role: "presentation",
    className: "chakra-select__icon",
    focusable: false,
    "aria-hidden": true,
    style: {
      width: "1em",
      height: "1em",
      color: "currentColor"
    }
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconWrapper, {
    ...rest,
    className: "chakra-select__icon-wrapper"
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(children) ? clone : null);
};
SelectIcon.displayName = "SelectIcon";



/***/ }),

/***/ "./node_modules/embla-carousel-autoplay/embla-carousel-autoplay.esm.js":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Autoplay; }
/* harmony export */ });
const defaultOptions = {
  active: true,
  breakpoints: {},
  delay: 4000,
  jump: false,
  playOnInit: true,
  stopOnInteraction: true,
  stopOnMouseEnter: false,
  stopOnLastSnap: false,
  rootNode: null
};

function Autoplay(userOptions = {}) {
  let options;
  let carousel;
  let interaction;
  let timer = 0;
  let jump = false;
  function init(embla, optionsHandler) {
    carousel = embla;
    const {
      mergeOptions,
      optionsAtMedia
    } = optionsHandler;
    const optionsBase = mergeOptions(defaultOptions, Autoplay.globalOptions);
    const allOptions = mergeOptions(optionsBase, userOptions);
    options = optionsAtMedia(allOptions);
    jump = options.jump;
    interaction = options.stopOnInteraction ? destroy : stop;
    const {
      eventStore
    } = carousel.internalEngine();
    const emblaRoot = carousel.rootNode();
    const root = options.rootNode && options.rootNode(emblaRoot) || emblaRoot;
    carousel.on('pointerDown', interaction);
    if (!options.stopOnInteraction) carousel.on('pointerUp', reset);
    if (options.stopOnMouseEnter) {
      eventStore.add(root, 'mouseenter', interaction);
      if (!options.stopOnInteraction) eventStore.add(root, 'mouseleave', reset);
    }
    eventStore.add(document, 'visibilitychange', () => {
      if (document.visibilityState === 'hidden') return stop();
      reset();
    });
    eventStore.add(window, 'pagehide', event => {
      if (event.persisted) stop();
    });
    if (options.playOnInit) play();
  }
  function destroy() {
    carousel.off('pointerDown', interaction);
    if (!options.stopOnInteraction) carousel.off('pointerUp', reset);
    stop();
    timer = 0;
  }
  function play(jumpOverride) {
    stop();
    if (typeof jumpOverride !== 'undefined') jump = jumpOverride;
    timer = window.setTimeout(next, options.delay);
  }
  function stop() {
    if (!timer) return;
    window.clearTimeout(timer);
  }
  function reset() {
    if (!timer) return;
    stop();
    play();
  }
  function next() {
    const {
      index
    } = carousel.internalEngine();
    const kill = options.stopOnLastSnap && index.get() === index.max;
    if (kill) return destroy();
    if (carousel.canScrollNext()) {
      carousel.scrollNext(jump);
    } else {
      carousel.scrollTo(0, jump);
    }
    play();
  }
  const self = {
    name: 'autoplay',
    options: userOptions,
    init,
    destroy,
    play,
    stop,
    reset
  };
  return self;
}
Autoplay.globalOptions = undefined;


//# sourceMappingURL=embla-carousel-autoplay.esm.js.map


/***/ }),

/***/ "./node_modules/lucide-react/dist/esm/createLucideIcon.js":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createLucideIcon; }
});

// UNUSED EXPORTS: toKebabCase

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/defaultAttributes.js
/**
 * @license lucide-react v0.312.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};


//# sourceMappingURL=defaultAttributes.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/createLucideIcon.js
/**
 * @license lucide-react v0.312.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */




const toKebabCase = (string) => string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase().trim();
const createLucideIcon = (iconName, iconNode) => {
  const Component = (0,react.forwardRef)(
    ({ color = "currentColor", size = 24, strokeWidth = 2, absoluteStrokeWidth, className = "", children, ...rest }, ref) => {
      return (0,react.createElement)(
        "svg",
        {
          ref,
          ...defaultAttributes,
          width: size,
          height: size,
          stroke: color,
          strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
          className: ["lucide", `lucide-${toKebabCase(iconName)}`, className].join(" "),
          ...rest
        },
        [
          ...iconNode.map(([tag, attrs]) => (0,react.createElement)(tag, attrs)),
          ...Array.isArray(children) ? children : [children]
        ]
      );
    }
  );
  Component.displayName = `${iconName}`;
  return Component;
};


//# sourceMappingURL=createLucideIcon.js.map


/***/ }),

/***/ "./node_modules/lucide-react/dist/esm/icons/chevron-left.js":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChevronLeft; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/lucide-react/dist/esm/createLucideIcon.js");
/**
 * @license lucide-react v0.312.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const ChevronLeft = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);


//# sourceMappingURL=chevron-left.js.map


/***/ }),

/***/ "./node_modules/lucide-react/dist/esm/icons/chevron-right.js":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChevronRight; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/lucide-react/dist/esm/createLucideIcon.js");
/**
 * @license lucide-react v0.312.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const ChevronRight = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);


//# sourceMappingURL=chevron-right.js.map


/***/ }),

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Findex.tsx&page=%2F!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__("./src/pages/index.tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./@lib/utils.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cn": function() { return /* binding */ cn; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/clsx/dist/clsx.mjs");
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/tailwind-merge/dist/bundle-mjs.mjs");


function cn() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_0__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .W)(inputs));
}


/***/ }),

/***/ "./src/components/Elements/Carousel/Carousel.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ WikiCarousel; },
/* harmony export */   "l": function() { return /* binding */ Carousel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var embla_carousel_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./node_modules/embla-carousel-react/esm/embla-carousel-react.esm.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./node_modules/react-icons/md/index.esm.js");
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/react-slick/lib/index.js");
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("./node_modules/react-icons/fa/index.esm.js");
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/slick-carousel/slick/slick.css");
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./node_modules/slick-carousel/slick/slick-theme.css");
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);











const WikiCarousel = (param)=>{
    let { options , plugins , Buttons , children  } = param;
    const [emblaRef, emblaApi] = (0,embla_carousel_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ...options
    }, plugins);
    const [selectedIndex, setSelectedIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [scrollSnaps, setScrollSnaps] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [prevBtnEnabled, setPrevBtnEnabled] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [nextBtnEnabled, setNextBtnEnabled] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const scrollTo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((index)=>{
        return emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollTo(index);
    }, [
        emblaApi
    ]);
    const onSelect = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        if (!emblaApi) return;
        setSelectedIndex(emblaApi.selectedScrollSnap());
        setPrevBtnEnabled(emblaApi.canScrollPrev());
        setNextBtnEnabled(emblaApi.canScrollNext());
    }, [
        emblaApi,
        setSelectedIndex
    ]);
    const scrollPrev = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        return emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollPrev();
    }, [
        emblaApi
    ]);
    const scrollNext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        return emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollNext();
    }, [
        emblaApi
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!emblaApi) return;
        onSelect();
        setScrollSnaps(emblaApi.scrollSnapList());
        emblaApi.on("select", onSelect);
        emblaApi.on("reInit", onSelect);
    }, [
        emblaApi,
        setScrollSnaps,
        onSelect
    ]);
    const PrevButton = (props)=>{
        const { enabled , onClick  } = props;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .zx, {
            className: "embla__button embla__button--prev",
            onClick: onClick,
            disabled: !enabled,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .JO, {
                as: react_icons_md__WEBPACK_IMPORTED_MODULE_8__/* .MdOutlineArrowBackIos */ .oTp
            })
        });
    };
    const NextButton = (props)=>{
        const { enabled , onClick  } = props;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .zx, {
            className: "embla__button embla__button--next",
            onClick: onClick,
            disabled: !enabled,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .JO, {
                as: react_icons_md__WEBPACK_IMPORTED_MODULE_8__/* .MdOutlineArrowForwardIos */ .Djl
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .chakra.div */ .m$.div, {
                ref: emblaRef,
                rounded: "12px",
                boxShadow: "3xl",
                _dark: {
                    shadow: "0px 25px 50px -12px rgba(16, 16, 17, 0.25)"
                },
                overflow: "hidden",
                w: "full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Flex */ .kC, {
                    w: "full",
                    children: children
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Flex */ .kC, {
                w: "full",
                alignItems: "center",
                gap: "3",
                pt: "6",
                justifyContent: "center",
                children: scrollSnaps.map((_, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .JO, {
                        as: react_icons_ri__WEBPACK_IMPORTED_MODULE_11__/* .RiCheckboxBlankCircleFill */ .o$3,
                        fontSize: "8px",
                        color: index !== selectedIndex ? "brand.200" : "brand.500",
                        cursor: "pointer",
                        onClick: ()=>scrollTo(index)
                    }, index))
            }),
            Buttons && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PrevButton, {
                        onClick: scrollPrev,
                        enabled: prevBtnEnabled
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NextButton, {
                        onClick: scrollNext,
                        enabled: nextBtnEnabled
                    })
                ]
            })
        ]
    });
};
const ArrowBtn = (param)=>/*#__PURE__*/ {
    let { ArrowIcon , onClick , top , isNext  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
        top: top,
        position: "absolute",
        transform: "translate(0, 150%)",
        display: "grid",
        placeItems: "center",
        onClick: onClick,
        cursor: "pointer",
        borderWidth: "1px",
        borderColor: "carouselArrowBorderColor",
        zIndex: 99,
        bgColor: "carouselArrowBg",
        borderRadius: "50%",
        w: {
            base: "35px",
            md: "40px"
        },
        h: {
            base: "35px",
            md: "40px"
        },
        right: isNext ? "0px" : "unset",
        left: isNext ? "unset" : "0px",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .JO, {
            as: ArrowIcon,
            color: "grey"
        })
    });
};
const Carousel = (param)=>/*#__PURE__*/ {
    let { settings , children , topArrow  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        ...settings,
        nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArrowBtn, {
            top: topArrow,
            ArrowIcon: react_icons_fa__WEBPACK_IMPORTED_MODULE_12__/* .FaChevronRight */ .Dli,
            isNext: true
        }),
        prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArrowBtn, {
            top: topArrow,
            ArrowIcon: react_icons_fa__WEBPACK_IMPORTED_MODULE_12__/* .FaChevronLeft */ .bUI
        }),
        children: children
    });
};


/***/ }),

/***/ "./src/components/Event/TrendingEvent.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ TrendingEventsCard; },
  "Z": function() { return /* binding */ Event_TrendingEvent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/embla-carousel-react/esm/embla-carousel-react.esm.js + 2 modules
var embla_carousel_react_esm = __webpack_require__("./node_modules/embla-carousel-react/esm/embla-carousel-react.esm.js");
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/chevron-left.js
var chevron_left = __webpack_require__("./node_modules/lucide-react/dist/esm/icons/chevron-left.js");
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/chevron-right.js
var chevron_right = __webpack_require__("./node_modules/lucide-react/dist/esm/icons/chevron-right.js");
// EXTERNAL MODULE: ./@lib/utils.ts
var utils = __webpack_require__("./@lib/utils.ts");
// EXTERNAL MODULE: ./src/components/ui/button.tsx
var ui_button = __webpack_require__("./src/components/ui/button.tsx");
;// CONCATENATED MODULE: ./src/components/ui/carousel.tsx






const CarouselContext = /*#__PURE__*/ react.createContext(null);
function useCarousel() {
    const context = react.useContext(CarouselContext);
    if (!context) {
        throw new Error("useCarousel must be used within a <Carousel />");
    }
    return context;
}
const Carousel = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { orientation ="horizontal" , opts , setApi , plugins , className , children , ...props } = param;
    const [carouselRef, api] = (0,embla_carousel_react_esm/* default */.Z)({
        ...opts,
        axis: orientation === "horizontal" ? "x" : "y"
    }, plugins);
    const [canScrollPrev, setCanScrollPrev] = react.useState(false);
    const [canScrollNext, setCanScrollNext] = react.useState(false);
    const onSelect = react.useCallback((api)=>{
        if (!api) {
            return;
        }
        setCanScrollPrev(api.canScrollPrev());
        setCanScrollNext(api.canScrollNext());
    }, []);
    const scrollPrev = react.useCallback(()=>{
        api === null || api === void 0 ? void 0 : api.scrollPrev();
    }, [
        api
    ]);
    const scrollNext = react.useCallback(()=>{
        api === null || api === void 0 ? void 0 : api.scrollNext();
    }, [
        api
    ]);
    const handleKeyDown = react.useCallback((event)=>{
        if (event.key === "ArrowLeft") {
            event.preventDefault();
            scrollPrev();
        } else if (event.key === "ArrowRight") {
            event.preventDefault();
            scrollNext();
        }
    }, [
        scrollPrev,
        scrollNext
    ]);
    react.useEffect(()=>{
        if (!api || !setApi) {
            return;
        }
        setApi(api);
    }, [
        api,
        setApi
    ]);
    react.useEffect(()=>{
        if (!api) {
            return;
        }
        onSelect(api);
        api.on("reInit", onSelect);
        api.on("select", onSelect);
        return ()=>{
            api === null || api === void 0 ? void 0 : api.off("select", onSelect);
        };
    }, [
        api,
        onSelect
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselContext.Provider, {
        value: {
            carouselRef,
            api: api,
            opts,
            orientation: orientation || ((opts === null || opts === void 0 ? void 0 : opts.axis) === "y" ? "vertical" : "horizontal"),
            scrollPrev,
            scrollNext,
            canScrollPrev,
            canScrollNext
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: ref,
            onKeyDownCapture: handleKeyDown,
            className: (0,utils.cn)("relative", className),
            role: "region",
            "aria-roledescription": "carousel",
            ...props,
            children: children
        })
    });
});
Carousel.displayName = "Carousel";
const CarouselContent = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { className , ...props } = param;
    const { carouselRef , orientation  } = useCarousel();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: carouselRef,
        className: "overflow-hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: ref,
            className: (0,utils.cn)("flex", orientation === "horizontal" ? "-ml-0" : "-mt-4 flex-col", className),
            ...props
        })
    });
});
CarouselContent.displayName = "CarouselContent";
const CarouselItem = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { className , ...props } = param;
    const { orientation  } = useCarousel();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        role: "group",
        "aria-roledescription": "slide",
        className: (0,utils.cn)("min-w-0 shrink-0 grow-0 basis-full", orientation === "horizontal" ? "pl-4" : "pt-4", className),
        ...props
    });
});
CarouselItem.displayName = "CarouselItem";
const CarouselPrevious = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { className , variant ="outline" , size ="icon" , ...props } = param;
    const { orientation , scrollPrev , canScrollPrev  } = useCarousel();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
        ref: ref,
        variant: variant,
        size: size,
        className: (0,utils.cn)("absolute hidden md:flex justify-center items-center disabled:hidden backdrop-blur-[10px] h-10 w-10 rounded-full", orientation === "horizontal" ? "-left-6 top-1/2 -translate-y-1/2" : "-top-12 left-1/2 -translate-x-1/2 rotate-90", className),
        disabled: !canScrollPrev,
        onClick: scrollPrev,
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_left/* default */.Z, {
                className: "h-6 w-6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: "Previous slide"
            })
        ]
    });
});
CarouselPrevious.displayName = "CarouselPrevious";
const CarouselNext = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { className , variant ="outline" , size ="icon" , ...props } = param;
    const { orientation , scrollNext , canScrollNext  } = useCarousel();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
        ref: ref,
        variant: variant,
        size: size,
        className: (0,utils.cn)("absolute hidden md:block h-10 backdrop-blur-[10px] w-10 p-2 rounded-full", orientation === "horizontal" ? "-right-6 top-1/2 -translate-y-1/2" : "-bottom-12 left-1/2 -translate-x-1/2 rotate-90", className),
        disabled: !canScrollNext,
        onClick: scrollNext,
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_right/* default */.Z, {
                className: "h-6 w-6 text-alpha-900"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: "Next slide"
            })
        ]
    });
});
CarouselNext.displayName = "CarouselNext";
const CarouselDots = ()=>{
    const { api  } = useCarousel();
    const [selectedIndex, setSelectedIndex] = react.useState(0);
    const [scrollSnaps, setScrollSnaps] = react.useState([]);
    const scrollTo = (index)=>{
        api === null || api === void 0 ? void 0 : api.scrollTo(index);
    };
    // Update dots when the carousel state changes
    const onSelect = ()=>{
        if (!api) return;
        setSelectedIndex(api.selectedScrollSnap());
        setScrollSnaps(api.scrollSnapList());
    };
    react.useEffect(()=>{
        if (!api) return;
        onSelect() // Initial setup
        ;
        api.on("reInit", onSelect);
        api.on("select", onSelect);
        return ()=>{
            api === null || api === void 0 ? void 0 : api.off("select", onSelect);
            api === null || api === void 0 ? void 0 : api.off("reInit", onSelect);
        };
    }, [
        api,
        onSelect
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center p-4",
        children: scrollSnaps.map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "h-[6px] w-[6px] mx-1 rounded-full ".concat(selectedIndex === index ? "bg-[#FF5CAA] dark:bg-[#FF1A88]" : "bg-brand-100"),
                onClick: ()=>scrollTo(index),
                "aria-label": "Go to slide ".concat(index + 1)
            }, index))
    });
};
CarouselDots.displayName = "CarouselDots";


// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__("./node_modules/next/image.js");
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var index_esm = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("./node_modules/next/link.js");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/embla-carousel-autoplay/embla-carousel-autoplay.esm.js
var embla_carousel_autoplay_esm = __webpack_require__("./node_modules/embla-carousel-autoplay/embla-carousel-autoplay.esm.js");
// EXTERNAL MODULE: ./src/utils/WikiUtils/getWikiImageUrl.ts
var getWikiImageUrl = __webpack_require__("./src/utils/WikiUtils/getWikiImageUrl.ts");
// EXTERNAL MODULE: ./src/lib/utils.ts
var lib_utils = __webpack_require__("./src/lib/utils.ts");
;// CONCATENATED MODULE: ./src/components/Event/TrendingEvent.tsx









const TrendingEventsCard = (param)=>{
    let { events  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Carousel, {
            plugins: [
                (0,embla_carousel_autoplay_esm/* default */.Z)()
            ],
            opts: {
                align: "start",
                loop: true
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselContent, {
                    className: "",
                    children: events === null || events === void 0 ? void 0 : events.map((event)=>{
                        var ref, ref1, ref2, ref3, ref4, ref5;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(CarouselItem, {
                            className: "h-[350px] xl:h-[300px] overflow-hidden basis-[80%] md:basis-[40%] xl:basis-[309px] rounded-xl relative ml-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: (0,getWikiImageUrl/* getWikiImageUrl */.A)(event.images),
                                    alt: "blockchain-expo",
                                    fill: true,
                                    priority: true,
                                    sizes: "80%, (min-width: 768px) 50%, 309px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                    href: "/events/".concat(event.title.toLowerCase().replace(/ /g, "-")),
                                    className: "absolute left-0 h-full bg-black/30 w-full flex flex-col justify-end px-2 py-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-alpha-900",
                                            children: [
                                                event.location && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "flex items-center gap-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* RiMapPinRangeLine */.nQI, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                            className: "text-sm",
                                                            children: event.location
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    className: "text-xl font-semibold",
                                                    children: event.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    className: "",
                                                    children: (event === null || event === void 0 ? void 0 : (ref = event.events) === null || ref === void 0 ? void 0 : ref[0].date) ? (0,lib_utils/* parseDateRange */.r0)(event === null || event === void 0 ? void 0 : (ref1 = event.events) === null || ref1 === void 0 ? void 0 : ref1[0].date) : (event === null || event === void 0 ? void 0 : (ref2 = event.events) === null || ref2 === void 0 ? void 0 : ref2[0].multiDateStart) && (event === null || event === void 0 ? void 0 : (ref3 = event.events) === null || ref3 === void 0 ? void 0 : ref3[0].multiDateEnd) ? (0,lib_utils/* parseDateRange */.r0)("".concat(event === null || event === void 0 ? void 0 : (ref4 = event.events) === null || ref4 === void 0 ? void 0 : ref4[0].multiDateStart, "/").concat(event === null || event === void 0 ? void 0 : (ref5 = event.events) === null || ref5 === void 0 ? void 0 : ref5[0].multiDateEnd)) : ""
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            className: "px-2 py-[10px] mt-5 text-alpha-900 rounded-[6px] text-xs font-semibold backdrop-blur-[30px] bg-alpha-300 w-fit",
                                            children: "View event details"
                                        })
                                    ]
                                })
                            ]
                        }, event.id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselPrevious, {
                    className: "backdrop-blur-[30px] bg-alpha-300"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselNext, {
                    className: "backdrop-blur-[30px] bg-alpha-300"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselDots, {})
            ]
        })
    });
};
const TrendingEvent = (param)=>{
    let { events  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-6 md:mt-[30px] max-w-[1296px] mx-auto ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "font-semibold text-xl 2xl:ml-4",
                children: "Trending Events"
            }),
            events.length > 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingEventsCard, {
                events: events
            })
        ]
    });
};
/* harmony default export */ var Event_TrendingEvent = (TrendingEvent);


/***/ }),

/***/ "./src/components/ui/button.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ buttonVariants; },
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@radix-ui/react-slot/dist/index.mjs");
/* harmony import */ var class_variance_authority__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/class-variance-authority/dist/index.mjs");
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./@lib/utils.ts");





const buttonVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_2__/* .cva */ .j)("inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 dark:ring-offset-slate-950 dark:focus-visible:ring-slate-300", {
    variants: {
        variant: {
            default: "bg-white text-slate-50 hover:bg-slate-900/90 dark:bg-[#2D3748]",
            destructive: "bg-red-500 text-slate-50 hover:bg-red-500/90 dark:bg-red-900 dark:text-slate-50 dark:hover:bg-red-900/90",
            outline: "border border-slate-200 bg-white hover:bg-slate-100 hover:text-slate-900 dark:border-slate-800 dark:bg-[#2D3748] dark:hover:bg-slate-800 dark:hover:text-slate-50",
            secondary: "bg-slate-100 text-slate-900 hover:bg-slate-100/80 dark:bg-slate-800 dark:text-slate-50 dark:hover:bg-slate-800/80",
            ghost: "hover:bg-slate-100 hover:text-slate-900 dark:hover:bg-slate-800 dark:hover:text-slate-50",
            link: "text-slate-900 underline-offset-4 hover:underline dark:text-slate-50"
        },
        size: {
            default: "h-10 px-4 py-2",
            sm: "h-9 rounded-md px-3",
            lg: "h-11 rounded-md px-8",
            icon: "h-10 w-10"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
const Button = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>{
    let { className , variant , size , asChild =false , ...props } = param;
    const Comp = asChild ? _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_3__/* .Slot */ .g7 : "button";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)(buttonVariants({
            variant,
            size,
            className
        })),
        ref: ref,
        ...props
    });
});
Button.displayName = "Button";



/***/ }),

/***/ "./src/lib/utils.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P7": function() { return /* binding */ dateFormater; },
/* harmony export */   "Qr": function() { return /* binding */ groupEventsByMonth; },
/* harmony export */   "cn": function() { return /* binding */ cn; },
/* harmony export */   "r0": function() { return /* binding */ parseDateRange; }
/* harmony export */ });
/* unused harmony export formatDate */
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/clsx/dist/clsx.mjs");
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/tailwind-merge/dist/bundle-mjs.mjs");


function cn() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_0__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .W)(inputs));
}
function formatDate(date) {
    const day = date.getDate();
    const suffix = [
        "th",
        "st",
        "nd",
        "rd"
    ];
    const suffixIndex = day % 10 === 1 && day !== 11 ? 1 : day % 10 === 2 && day !== 12 ? 2 : day % 10 === 3 && day !== 13 ? 3 : 0;
    return day + suffix[suffixIndex];
}
function parseDateRange(isoString) {
    const dates = isoString.split("/");
    const start = new Date(dates[0]);
    const end = dates.length > 1 ? new Date(dates[1]) : null;
    const startFormatted = formatDate(start);
    const endFormatted = end ? formatDate(end) : null;
    const month = start.toLocaleString("en-US", {
        month: "long"
    });
    const year = start.getFullYear();
    if (end) {
        const endMonth = end.toLocaleString("en-US", {
            month: "long"
        });
        const endYear = end.getFullYear();
        if (month === endMonth) {
            return "".concat(startFormatted, "-").concat(endFormatted, ", ").concat(month, " ").concat(year);
        } else {
            return "".concat(startFormatted, ", ").concat(month, " ").concat(year, " - ").concat(endFormatted, ", ").concat(endMonth, " ").concat(endYear);
        }
    } else {
        return "".concat(startFormatted, ", ").concat(month, " ").concat(year);
    }
}
const dateFormater = (date)=>{
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0") // Add 1 because months are 0-indexed, and pad with leading zero if necessary
    ;
    const day = String(date.getDate()).padStart(2, "0");
    return "".concat(year, "-").concat(month, "-").concat(day);
};
const groupEventsByMonth = (events)=>{
    const eventsByMonth = {};
    // Group events by month and year
    events.forEach((event)=>{
        var ref, ref1, ref2, ref3;
        const date = (event === null || event === void 0 ? void 0 : (ref = event.events) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.date) || (event === null || event === void 0 ? void 0 : (ref2 = event.events) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.multiDateStart);
        if (date) {
            const dateParts = date.split("-");
            if (dateParts.length >= 2) {
                const monthNumeric = parseInt(dateParts[1], 10);
                const monthWord = new Date(2000, monthNumeric - 1, 1).toLocaleString("en-us", {
                    month: "long"
                });
                const key = "".concat(monthWord, " ").concat(dateParts[0]);
                if (!eventsByMonth[key]) {
                    eventsByMonth[key] = [];
                }
                eventsByMonth[key].push(event);
            }
        }
    });
    // Sort the keys (Month Year) in ascending order and create a sorted object
    const sortedKeys = Object.keys(eventsByMonth).sort((a, b)=>{
        const yearA = parseInt(a.split(" ")[1], 10);
        const yearB = parseInt(b.split(" ")[1], 10);
        const monthA = new Date("".concat(a.split(" ")[0], " 1 2000")).getMonth();
        const monthB = new Date("".concat(b.split(" ")[0], " 1 2000")).getMonth();
        if (yearA > yearB) return 1;
        if (yearA < yearB) return -1;
        return monthA - monthB;
    });
    const sortedEventsByMonth = {};
    sortedKeys.forEach((key)=>{
        sortedEventsByMonth[key] = eventsByMonth[key];
    });
    return sortedEventsByMonth;
};


/***/ }),

/***/ "./src/pages/index.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Index": function() { return /* binding */ Index; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__("./node_modules/next/dynamic.js");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/select/dist/index.esm.js
var select_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/select/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__("./node_modules/next/router.js");
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js + 1 modules
var chakra_ui_icons_esm = __webpack_require__("./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js");
// EXTERNAL MODULE: ./src/data/Constants.ts
var Constants = __webpack_require__("./src/data/Constants.ts");
// EXTERNAL MODULE: ./src/utils/textUtils.ts
var textUtils = __webpack_require__("./src/utils/textUtils.ts");
// EXTERNAL MODULE: ./src/utils/WikiUtils/getWikiImageUrl.ts
var getWikiImageUrl = __webpack_require__("./src/utils/WikiUtils/getWikiImageUrl.ts");
// EXTERNAL MODULE: ./src/components/Elements/index.ts + 11 modules
var Elements = __webpack_require__("./src/components/Elements/index.ts");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 6 modules
var system_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/skeleton/dist/index.esm.js + 1 modules
var skeleton_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/skeleton/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Landing/LoadingFeaturedWikiCard.tsx



const TrendingSkeleton = ()=>{
    const itemsCount = [
        1,
        2,
        3,
        4
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
        w: "full",
        pt: {
            base: "2",
            lg: "4"
        },
        px: "2",
        gap: "5",
        overflow: "hidden",
        children: itemsCount.map((_item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                w: "full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.span */.m$.span, {
                        minW: "2",
                        alignSelf: "center",
                        children: i + 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                        rounded: "lg",
                        w: {
                            base: "55px",
                            md: "65px",
                            lg: "75px"
                        },
                        h: {
                            base: "48px",
                            md: "55px",
                            lg: "63px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                        w: "full",
                        alignItems: "start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                rounded: "lg",
                                h: "16px",
                                w: "100px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                rounded: "lg",
                                h: "14px",
                                w: "280px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                rounded: "lg",
                                h: "14px",
                                w: "180px"
                            })
                        ]
                    })
                ]
            }))
    });
};
const LoadingFeaturedWikiCard = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.div */.m$.div, {
        px: 2,
        mx: "auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
            alignSelf: "center",
            direction: "column",
            textAlign: "left",
            bg: "white",
            _dark: {
                bgColor: "gray.700",
                color: "white"
            },
            cursor: "pointer",
            rounded: "lg",
            shadow: "md",
            gap: "2",
            pb: "3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                    w: "full",
                    height: "250px",
                    rounded: "md"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    direction: "column",
                    px: "5",
                    gap: "2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            rounded: "lg",
                            h: "16px",
                            w: "100px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            rounded: "lg",
                            h: "14px",
                            w: "280px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            rounded: "lg",
                            h: "14px",
                            w: "180px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                    alignItems: "center",
                                    gap: 3,
                                    width: "50%",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* SkeletonCircle */.s7, {
                                            size: "30px"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                            rounded: "lg",
                                            h: "18px",
                                            w: "60px"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                    rounded: "lg",
                                    h: "18px",
                                    w: "100px"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/Elements/Image/Image.tsx
var Image = __webpack_require__("./src/components/Elements/Image/Image.tsx");
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 23 modules
var esm = __webpack_require__("./node_modules/next-i18next/dist/esm/index.js");
;// CONCATENATED MODULE: ./src/components/Landing/TrendingCard.tsx












const TrendingCard = (param)=>{
    let { wikis =[] , title , icon , isTrending  } = param;
    const [wikiData, setWikiData] = react.useState(isTrending ? wikis.todayTrending : wikis);
    const { t  } = (0,esm/* useTranslation */.$G)("home");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
        py: "1",
        maxW: {
            base: "min(90vw, 400px)",
            md: "96",
            lg: "392"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
            w: "full",
            rounded: "lg",
            border: "1px solid",
            borderColor: "gray.100",
            minH: "500px",
            py: 5,
            bg: "white",
            _dark: {
                bgColor: "gray.700",
                border: "none"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    w: "full",
                    alignItems: "center",
                    px: "4",
                    mb: "2",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                                    cursor: "pointer",
                                    fontSize: "2xl",
                                    fontWeight: 600,
                                    color: "brandLinkColor",
                                    as: icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    color: "wikiFlagTextColor",
                                    fontSize: {
                                        base: "md",
                                        lg: "18px"
                                    },
                                    pl: 2,
                                    fontWeight: "600",
                                    children: title
                                })
                            ]
                        }),
                        isTrending && /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_dist_index_esm/* Select */.Ph, {
                            h: "30px",
                            fontSize: "12px",
                            w: "120px",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* ChevronDownIcon */.v4, {}),
                            mr: "2",
                            borderColor: "rankingListBorder",
                            onChange: (e)=>{
                                setWikiData(wikis[e.target.value]);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "todayTrending",
                                    children: t("Today")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "weekTrending",
                                    children: t("Last Week")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "monthTrending",
                                    children: t("Last Month")
                                })
                            ]
                        })
                    ]
                }),
                wikis ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                    direction: "column",
                    w: "full",
                    px: "2",
                    overflow: "hidden",
                    children: wikiData === null || wikiData === void 0 ? void 0 : wikiData.map((wiki, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HStack */.Ug, {
                            w: "full",
                            _hover: {
                                borderRadius: "md",
                                bgColor: "gray.100",
                                _dark: {
                                    bgColor: "whiteAlpha.100"
                                }
                            },
                            cursor: "pointer",
                            mt: 0,
                            py: 2,
                            px: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                href: "/wiki/".concat(wiki.id),
                                _hover: {
                                    textDecoration: "none"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AspectRatio */.oM, {
                                                ratio: Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
                                                w: {
                                                    base: "50px",
                                                    md: "60px",
                                                    lg: "70px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                    src: (0,getWikiImageUrl/* getWikiImageUrl */.A)(wiki.images),
                                                    alt: wiki.title,
                                                    borderRadius: "md",
                                                    overflow: "hidden",
                                                    imgW: Constants/* IMAGE_BOX_SIZE */.xh * Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
                                                    imgH: Constants/* IMAGE_BOX_SIZE */.xh
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                            direction: "column",
                                            justifyContent: "flex-start",
                                            textAlign: "start",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    fontWeight: "semibold",
                                                    color: "wikiFlagTextColor",
                                                    fontSize: "18px",
                                                    overflow: "hidden",
                                                    onClick: ()=>router_default().push("wiki/".concat(wiki.id)),
                                                    children: (0,textUtils/* shortenText */.El)(wiki.title, 24)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    display: {
                                                        base: "none",
                                                        md: "-webkit-box"
                                                    },
                                                    noOfLines: 2,
                                                    w: "97%",
                                                    textOverflow: "ellipsis",
                                                    overflow: "hidden",
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                    color: "homeDescriptionColor",
                                                    children: wiki.summary
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }, i))
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingSkeleton, {})
            ]
        })
    });
};
/* harmony default export */ var Landing_TrendingCard = (TrendingCard);

// EXTERNAL MODULE: ./src/hooks/useENSData.ts
var useENSData = __webpack_require__("./src/hooks/useENSData.ts");
// EXTERNAL MODULE: ./src/utils/DataTransform/getFormattedDate.ts
var getFormattedDate = __webpack_require__("./src/utils/DataTransform/getFormattedDate.ts");
// EXTERNAL MODULE: ./src/utils/DataTransform/getUsername.ts
var getUsername = __webpack_require__("./src/utils/DataTransform/getUsername.ts");
// EXTERNAL MODULE: ./src/utils/WikiUtils/getWikiSummary.ts
var getWikiSummary = __webpack_require__("./src/utils/WikiUtils/getWikiSummary.ts");
// EXTERNAL MODULE: ./src/components/Elements/Avatar/DisplayAvatar.tsx
var DisplayAvatar = __webpack_require__("./src/components/Elements/Avatar/DisplayAvatar.tsx");
// EXTERNAL MODULE: ./src/components/Elements/LinkElements/LinkOverlay.tsx
var LinkOverlay = __webpack_require__("./src/components/Elements/LinkElements/LinkOverlay.tsx");
// EXTERNAL MODULE: ./src/components/Elements/LinkElements/Link.tsx
var Link = __webpack_require__("./src/components/Elements/LinkElements/Link.tsx");
;// CONCATENATED MODULE: ./src/components/Landing/FeaturedWikiCard.tsx















const FeaturedWikiCard = (param)=>{
    let { wiki  } = param;
    var ref, ref1, ref2;
    const [, ensName] = (0,useENSData/* useENSData */.L)(wiki.user.id);
    const { t  } = (0,esm/* useTranslation */.$G)("wiki");
    const getLatestEdited = ()=>{
        let lastEditedTime = null;
        if (wiki.updated) {
            lastEditedTime = (0,getFormattedDate/* getReadableDate */._)(wiki.updated);
        } else if (wiki.created) {
            lastEditedTime = (0,getFormattedDate/* getReadableDate */._)(wiki.created);
        }
        return lastEditedTime === null || lastEditedTime === void 0 ? void 0 : lastEditedTime.split(" ")[0];
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* LinkBox */.fG, {
        flex: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.div */.m$.div, {
            mx: "auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                alignSelf: "center",
                direction: "column",
                textAlign: "left",
                bgColor: "bodyBg",
                cursor: "pointer",
                rounded: "lg",
                mx: "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AspectRatio */.oM, {
                        ratio: Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
                        h: {
                            base: "250px",
                            md: "250px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            src: (0,getWikiImageUrl/* getWikiImageUrl */.A)(wiki.images),
                            alt: wiki.title,
                            borderTopRadius: "md",
                            overflow: "hidden",
                            objectFit: "cover",
                            imgW: Constants/* IMAGE_BOX_SIZE */.xh * Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
                            imgH: Constants/* IMAGE_BOX_SIZE */.xh
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                        direction: "column",
                        justify: "space-between",
                        fontWeight: "semibold",
                        p: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkOverlay/* default */.Z, {
                                href: "/wiki/".concat(wiki === null || wiki === void 0 ? void 0 : wiki.id),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                    width: "80%",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    color: "wikiFlagTextColor",
                                    fontSize: {
                                        base: "14px",
                                        md: "18px"
                                    },
                                    fontWeight: "600",
                                    children: (0,textUtils/* shortenText */.El)(wiki === null || wiki === void 0 ? void 0 : wiki.title, 30)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontSize: "12px",
                                maxW: "90%",
                                minH: 12,
                                color: "homeDescriptionColor",
                                my: 2,
                                fontWeight: "500",
                                children: wiki && (0,getWikiSummary/* getWikiSummary */.L)(wiki, getWikiSummary/* WikiSummarySize.Small */.D.Small)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                justify: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                        alignItems: "center",
                                        gap: 3,
                                        width: "50%",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                href: "/account/".concat(wiki === null || wiki === void 0 ? void 0 : (ref = wiki.user) === null || ref === void 0 ? void 0 : ref.id),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayAvatar/* default */.Z, {
                                                    alt: (0,getUsername/* getUsername */.M)(wiki === null || wiki === void 0 ? void 0 : wiki.user, ensName),
                                                    size: 20,
                                                    address: wiki === null || wiki === void 0 ? void 0 : wiki.user.id,
                                                    avatarIPFS: (ref1 = wiki === null || wiki === void 0 ? void 0 : wiki.user.profile) === null || ref1 === void 0 ? void 0 : ref1.avatar
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                href: "/account/".concat(wiki === null || wiki === void 0 ? void 0 : (ref2 = wiki.user) === null || ref2 === void 0 ? void 0 : ref2.id),
                                                color: "brand.500 !important",
                                                fontSize: "sm",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                children: (0,getUsername/* getUsername */.M)(wiki === null || wiki === void 0 ? void 0 : wiki.user, ensName)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                        width: "50%",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        color: "gray.400",
                                        _dark: {
                                            color: "whiteAlpha.900"
                                        },
                                        fontWeight: "400",
                                        fontSize: "sm",
                                        textAlign: "right",
                                        children: [
                                            t("LastEdited"),
                                            " ",
                                            getLatestEdited(),
                                            " ",
                                            t("days")
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/embla-carousel-autoplay/embla-carousel-autoplay.esm.js
var embla_carousel_autoplay_esm = __webpack_require__("./node_modules/embla-carousel-autoplay/embla-carousel-autoplay.esm.js");
// EXTERNAL MODULE: ./src/components/Elements/Carousel/Carousel.tsx
var Carousel = __webpack_require__("./src/components/Elements/Carousel/Carousel.tsx");
;// CONCATENATED MODULE: ./src/components/Landing/FeaturedWikis.tsx









const FeaturedWikis = (param)=>{
    let { featuredWikis  } = param;
    const OPTIONS = {
        loop: true
    };
    const { t  } = (0,esm/* useTranslation */.$G)("home");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
        pt: "1",
        minH: "500px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
            maxW: {
                base: "min(90vw, 400px)",
                md: "96",
                lg: "392"
            },
            w: "full",
            border: "1px solid",
            borderColor: "gray.100",
            rounded: "lg",
            py: 3,
            bgColor: "bodyBg",
            _dark: {
                border: "none"
            },
            textAlign: "center",
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(system_dist_index_esm/* chakra.div */.m$.div, {
                    w: "full",
                    alignItems: "center",
                    display: "flex",
                    px: "4",
                    pb: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                            cursor: "pointer",
                            color: "brandLinkColor",
                            fontSize: "2xl",
                            fontWeight: 600,
                            as: ri_index_esm/* RiStarFill */.Kz
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            color: "wikiFlagTextColor",
                            fontSize: {
                                base: "md",
                                lg: "18px"
                            },
                            pl: 2,
                            fontWeight: "600",
                            children: t("featuredWikisTitle")
                        })
                    ]
                }),
                featuredWikis ? /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.div */.m$.div, {
                    px: 5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* WikiCarousel */.B, {
                        plugins: [
                            (0,embla_carousel_autoplay_esm/* default */.Z)()
                        ],
                        options: OPTIONS,
                        children: featuredWikis.map((wiki)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                flex: "0 0 100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedWikiCard, {
                                    wiki: wiki
                                })
                            }, "wiki-".concat(wiki.id)))
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingFeaturedWikiCard, {})
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Landing/TrendingWikis.tsx







const TrendingWikis = (param)=>{
    let { trending , recent =[] , featuredWikis =[]  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)("home");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        mt: 10,
        px: {
            base: 3,
            md: 8
        },
        pb: {
            base: 16,
            md: 20,
            lg: 24
        },
        pt: 0,
        textAlign: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
            alignItems: "center",
            justifyContent: "center",
            maxW: {
                base: "403px",
                md: "fit-content"
            },
            mx: "auto",
            flexWrap: "wrap",
            gap: 4,
            minH: "500px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Landing_TrendingCard, {
                    title: t("trendingWikisTitle"),
                    icon: ri_index_esm/* RiBarChartFill */.jwm,
                    wikis: trending,
                    isTrending: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Landing_TrendingCard, {
                    title: t("recentEditsTitle"),
                    icon: ri_index_esm/* RiTimeFill */.N$g,
                    wikis: recent
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedWikis, {
                    featuredWikis: featuredWikis
                })
            ]
        })
    });
};
/* harmony default export */ var Landing_TrendingWikis = (TrendingWikis);

;// CONCATENATED MODULE: ./src/components/Landing/Hero.tsx




const Hero = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)("home");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                w: "full",
                textAlign: "center",
                px: {
                    base: "5",
                    md: "0"
                },
                fontSize: {
                    base: "24",
                    md: "36"
                },
                children: [
                    t("hero_heading1"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(system_dist_index_esm/* chakra.span */.m$.span, {
                        color: "brandLinkColor",
                        children: [
                            " ",
                            t("hero_heading2"),
                            " "
                        ]
                    }),
                    " ",
                    t("hero_heading3")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                px: {
                    base: "5",
                    md: "0"
                },
                textAlign: "center",
                mt: "3",
                mx: "auto",
                maxW: "590px",
                color: "eventTextColor",
                fontSize: {
                    base: "md",
                    lg: "20px"
                },
                children: t("iq_description")
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 16 modules
var es = __webpack_require__("./node_modules/react-i18next/dist/es/index.js");
// EXTERNAL MODULE: ./src/services/event/index.ts + 1 modules
var services_event = __webpack_require__("./src/services/event/index.ts");
// EXTERNAL MODULE: ./src/lib/utils.ts
var utils = __webpack_require__("./src/lib/utils.ts");
// EXTERNAL MODULE: ./src/components/Event/TrendingEvent.tsx + 1 modules
var TrendingEvent = __webpack_require__("./src/components/Event/TrendingEvent.tsx");
;// CONCATENATED MODULE: ./src/components/Landing/EventOverview.tsx







const EventOverview = ()=>{
    const { data  } = (0,services_event/* useGetEventsQuery */.kg)({
        offset: 0,
        limit: 4,
        startDate: (0,utils/* dateFormater */.P7)(new Date())
    });
    const { t  } = (0,es.useTranslation)("event");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data && data.length > 4 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-[1296px] mx-auto py-14 md:py-20 xl:py-24 px-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-2xl max-w-[350px] mx-auto md:max-w-full md:text-4xl font-semibold text-center",
                    children: t("homePageHeading")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid md:grid-cols-2 gap-14 mt-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-10",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-center md:text-start text-sm md:text-base",
                                        children: t("eventDescription")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* LinkButton */.Qj, {
                                        href: "/events",
                                        h: "50px",
                                        display: {
                                            base: "none",
                                            md: "flex"
                                        },
                                        w: {
                                            base: 32,
                                            lg: 40
                                        },
                                        variant: "outline",
                                        bgColor: "btnBgColor",
                                        prefetch: false,
                                        children: t("homePageAction")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingEvent/* TrendingEventsCard */.a, {
                                events: data || []
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Landing_EventOverview = (EventOverview);

;// CONCATENATED MODULE: ./src/pages/index.tsx





const CategoriesList = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5366).then(__webpack_require__.bind(__webpack_require__, "./src/components/Landing/CategoriesList.tsx")), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/("./src/components/Landing/CategoriesList.tsx")
            ]
    }
});
const DiscoverMore = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8424).then(__webpack_require__.bind(__webpack_require__, "./src/components/Landing/DiscoverMore.tsx")), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/("./src/components/Landing/DiscoverMore.tsx")
            ]
    }
});
const LeaderBoard = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9184).then(__webpack_require__.bind(__webpack_require__, "./src/components/Landing/Leaderboard.tsx")), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/("./src/components/Landing/Leaderboard.tsx")
            ]
    }
});
const RankingList = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4617), __webpack_require__.e(3874), __webpack_require__.e(2065), __webpack_require__.e(9522), __webpack_require__.e(4610)]).then(__webpack_require__.bind(__webpack_require__, "./src/components/Landing/RankingList.tsx")), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/("./src/components/Landing/RankingList.tsx")
            ]
    }
});

const AboutIqgpt = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7340).then(__webpack_require__.bind(__webpack_require__, "./src/components/Landing/AboutIqgpt.tsx")), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/("./src/components/Landing/AboutIqgpt.tsx")
            ]
    }
});

const RANKING_LIST_LIMIT = 10;
var __N_SSP = true;
const Index = (param)=>{
    let { promotedWikis , recentWikis , popularTags , leaderboards , rankings , trending  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
        _dark: {
            bgColor: "#1A202C"
        },
        direction: "column",
        mx: "auto",
        w: "full",
        pt: {
            base: 6,
            lg: 12
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Landing_TrendingWikis, {
                        trending: trending,
                        recent: recentWikis === null || recentWikis === void 0 ? void 0 : recentWikis.slice(0, 5),
                        featuredWikis: promotedWikis
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingList, {
                        listingLimit: RANKING_LIST_LIMIT,
                        rankings: rankings
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutIqgpt, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesList, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Landing_EventOverview, {})
                ]
            }),
            leaderboards.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeaderBoard, {
                leaderboards: leaderboards
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoverMore, {
                tagsData: popularTags
            })
        ]
    });
};
/* harmony default export */ var pages = (Index);


/***/ }),

/***/ "./src/utils/DataTransform/getFormattedDate.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getReadableDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/date-fns/formatDistanceToNowStrict.mjs");

const getReadableDate = (dateToFormat)=>{
    const parsedDate = new Date(dateToFormat);
    if (isNaN(parsedDate.getTime())) {
        return "";
    }
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* .formatDistanceToNowStrict */ .D)(parsedDate, {
        addSuffix: false
    });
};


/***/ }),

/***/ "./src/utils/DataTransform/getUsername.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ getUsername; }
/* harmony export */ });
/* harmony import */ var _textUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/utils/textUtils.ts");

const getUsername = (user, ensDomain)=>{
    var ref;
    if (!user) {
        return "Unknown";
    }
    if ((ref = user.profile) === null || ref === void 0 ? void 0 : ref.username) {
        return user.profile.username;
    }
    if (ensDomain) {
        return ensDomain;
    }
    return user.id ? (0,_textUtils__WEBPACK_IMPORTED_MODULE_0__/* .shortenAccount */ .p0)(user.id) : "Unknown";
};


/***/ }),

/***/ "./src/utils/WikiUtils/getWikiImageUrl.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getWikiImageUrl; }
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/config/index.ts");

const getWikiImageUrl = (imageObj)=>{
    var ref;
    return "".concat(_config__WEBPACK_IMPORTED_MODULE_0__/* ["default"].pinataBaseUrl */ .Z.pinataBaseUrl).concat(imageObj ? (ref = imageObj[0]) === null || ref === void 0 ? void 0 : ref.id : "");
};


/***/ }),

/***/ "./node_modules/@radix-ui/react-compose-refs/dist/index.mjs":
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ $6ed0406888f73fc4$export$43e446d32b3d21af; },
/* harmony export */   "e": function() { return /* binding */ $6ed0406888f73fc4$export$c7b2cbe3552a0d05; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/index.js");



/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$6ed0406888f73fc4$var$setRef(ref, node)
        )
    ;
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)($6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ "./node_modules/@radix-ui/react-slot/dist/index.mjs":
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g7": function() { return /* binding */ $5e63c961fc1ce211$export$8c6ed5c666ac1360; }
/* harmony export */ });
/* unused harmony exports Slottable, Root */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@babel/runtime/helpers/esm/extends.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@radix-ui/react-compose-refs/dist/index.mjs");







/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(children);
    const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if (react__WEBPACK_IMPORTED_MODULE_0__.Children.count(newElement) > 1) return react__WEBPACK_IMPORTED_MODULE_0__.Children.only(null);
                return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($5e63c961fc1ce211$var$SlotClone, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(newElement) ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($5e63c961fc1ce211$var$SlotClone, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = 'Slot';
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(children)) return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(children, {
        ...$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__/* .composeRefs */ .F)(forwardedRef, children.ref) : children.ref
    });
    return react__WEBPACK_IMPORTED_MODULE_0__.Children.count(children) > 1 ? react__WEBPACK_IMPORTED_MODULE_0__.Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = 'SlotClone';
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === 'style') overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === 'className') overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(' ');
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $5e63c961fc1ce211$export$be92b6f5f03c0fe9 = (/* unused pure expression or super */ null && ($5e63c961fc1ce211$export$8c6ed5c666ac1360));





//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ "./node_modules/class-variance-authority/dist/index.mjs":
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ cva; }
});

// UNUSED EXPORTS: cx

;// CONCATENATED MODULE: ./node_modules/class-variance-authority/node_modules/clsx/dist/clsx.mjs
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var dist_clsx = ((/* unused pure expression or super */ null && (clsx)));
;// CONCATENATED MODULE: ./node_modules/class-variance-authority/dist/index.mjs

const falsyToString = (value)=>typeof value === "boolean" ? "".concat(value) : value === 0 ? "0" : value;
const cx = clsx;
const cva = (base, config)=>{
    return (props)=>{
        var ref;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return cx(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants , defaultVariants  } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = falsyToString(variantProp) || falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) {
                return acc;
            }
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (ref = config.compoundVariants) === null || ref === void 0 ? void 0 : ref.reduce((acc, param1)=>{
            let { class: cvClass , className: cvClassName , ...compoundVariantOptions } = param1;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return cx(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };
};


//# sourceMappingURL=index.mjs.map

/***/ }),

/***/ "./node_modules/date-fns/formatDistanceToNowStrict.mjs":
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ formatDistanceToNowStrict; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/date-fns/locale/en-US.mjs + 1 modules
var en_US = __webpack_require__("./node_modules/date-fns/locale/en-US.mjs");
// EXTERNAL MODULE: ./node_modules/date-fns/_lib/defaultOptions.mjs
var _lib_defaultOptions = __webpack_require__("./node_modules/date-fns/_lib/defaultOptions.mjs");
;// CONCATENATED MODULE: ./node_modules/date-fns/_lib/getRoundingMethod.mjs
function getRoundingMethod(method) {
  return (number) => {
    const round = method ? Math[method] : Math.trunc;
    const result = round(number);
    // Prevent negative zero
    return result === 0 ? 0 : result;
  };
}

// EXTERNAL MODULE: ./node_modules/date-fns/_lib/getTimezoneOffsetInMilliseconds.mjs
var getTimezoneOffsetInMilliseconds = __webpack_require__("./node_modules/date-fns/_lib/getTimezoneOffsetInMilliseconds.mjs");
// EXTERNAL MODULE: ./node_modules/date-fns/toDate.mjs
var toDate = __webpack_require__("./node_modules/date-fns/toDate.mjs");
;// CONCATENATED MODULE: ./node_modules/date-fns/compareAsc.mjs


/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc(dateLeft, dateRight) {
  const _dateLeft = (0,toDate/* toDate */.Q)(dateLeft);
  const _dateRight = (0,toDate/* toDate */.Q)(dateRight);

  const diff = _dateLeft.getTime() - _dateRight.getTime();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_compareAsc = ((/* unused pure expression or super */ null && (compareAsc)));

// EXTERNAL MODULE: ./node_modules/date-fns/constants.mjs
var constants = __webpack_require__("./node_modules/date-fns/constants.mjs");
;// CONCATENATED MODULE: ./node_modules/date-fns/formatDistanceStrict.mjs








/**
 * The {@link formatDistanceStrict} function options.
 */

/**
 * The unit used to format the distance in {@link formatDistanceStrict}.
 */

/**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */

function formatDistanceStrict(date, baseDate, options) {
  const defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  const locale = options?.locale ?? defaultOptions.locale ?? en_US/* enUS */._;

  const comparison = compareAsc(date, baseDate);

  if (isNaN(comparison)) {
    throw new RangeError("Invalid time value");
  }

  const localizeOptions = Object.assign({}, options, {
    addSuffix: options?.addSuffix,
    comparison: comparison,
  });

  let dateLeft;
  let dateRight;
  if (comparison > 0) {
    dateLeft = (0,toDate/* toDate */.Q)(baseDate);
    dateRight = (0,toDate/* toDate */.Q)(date);
  } else {
    dateLeft = (0,toDate/* toDate */.Q)(date);
    dateRight = (0,toDate/* toDate */.Q)(baseDate);
  }

  const roundingMethod = getRoundingMethod(options?.roundingMethod ?? "round");

  const milliseconds = dateRight.getTime() - dateLeft.getTime();
  const minutes = milliseconds / constants/* millisecondsInMinute */.yJ;

  const timezoneOffset =
    (0,getTimezoneOffsetInMilliseconds/* getTimezoneOffsetInMilliseconds */.D)(dateRight) -
    (0,getTimezoneOffsetInMilliseconds/* getTimezoneOffsetInMilliseconds */.D)(dateLeft);

  // Use DST-normalized difference in minutes for years, months and days;
  // use regular difference in minutes for hours, minutes and seconds.
  const dstNormalizedMinutes =
    (milliseconds - timezoneOffset) / constants/* millisecondsInMinute */.yJ;

  const defaultUnit = options?.unit;
  let unit;
  if (!defaultUnit) {
    if (minutes < 1) {
      unit = "second";
    } else if (minutes < 60) {
      unit = "minute";
    } else if (minutes < constants/* minutesInDay */.H_) {
      unit = "hour";
    } else if (dstNormalizedMinutes < constants/* minutesInMonth */.fH) {
      unit = "day";
    } else if (dstNormalizedMinutes < constants/* minutesInYear */.UU) {
      unit = "month";
    } else {
      unit = "year";
    }
  } else {
    unit = defaultUnit;
  }

  // 0 up to 60 seconds
  if (unit === "second") {
    const seconds = roundingMethod(milliseconds / 1000);
    return locale.formatDistance("xSeconds", seconds, localizeOptions);

    // 1 up to 60 mins
  } else if (unit === "minute") {
    const roundedMinutes = roundingMethod(minutes);
    return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);

    // 1 up to 24 hours
  } else if (unit === "hour") {
    const hours = roundingMethod(minutes / 60);
    return locale.formatDistance("xHours", hours, localizeOptions);

    // 1 up to 30 days
  } else if (unit === "day") {
    const days = roundingMethod(dstNormalizedMinutes / constants/* minutesInDay */.H_);
    return locale.formatDistance("xDays", days, localizeOptions);

    // 1 up to 12 months
  } else if (unit === "month") {
    const months = roundingMethod(dstNormalizedMinutes / constants/* minutesInMonth */.fH);
    return months === 12 && defaultUnit !== "month"
      ? locale.formatDistance("xYears", 1, localizeOptions)
      : locale.formatDistance("xMonths", months, localizeOptions);

    // 1 year up to max Date
  } else {
    const years = roundingMethod(dstNormalizedMinutes / constants/* minutesInYear */.UU);
    return locale.formatDistance("xYears", years, localizeOptions);
  }
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_formatDistanceStrict = ((/* unused pure expression or super */ null && (formatDistanceStrict)));

;// CONCATENATED MODULE: ./node_modules/date-fns/formatDistanceToNowStrict.mjs


/**
 * The {@link formatDistanceToNowStrict} function options.
 */

/**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */
function formatDistanceToNowStrict(date, options) {
  return formatDistanceStrict(date, Date.now(), options);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_formatDistanceToNowStrict = ((/* unused pure expression or super */ null && (formatDistanceToNowStrict)));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,5099,4116,8159,9382,4797,9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Findex.tsx&page=%2F!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);